import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-main heading-s hover:bg-bg-items-white flex size-10 cursor-pointer items-center justify-center rounded-full bg-transparent transition-colors duration-150 sm:size-12.5'
  },
  variants: {
    selected: {
      true: 'bg-bg-items-white heading-s-bold pointer-events-none cursor-default'
    },
    disabled: {
      true: 'text-inactive pointer-events-none cursor-default'
    }
  }
});
